import tokml from "geojson-to-kml";

export default {
  methods: {
    methodDownloadKML(geoJson, nameField, filename) {
      if (geoJson) {
        const kml = tokml(geoJson, {
          name: nameField
        });
        const blob = new Blob([kml], { type: "octet/stream" });

        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      }
    },
    // Global method to toggle a map layer on or off
    methodToggleMapLayer(dept, layer) {
      this.$store.commit("mutationMapLayer", {
        dept: dept,
        layer: layer
      });
    },
    // Global method to toggle list view
    methodToggleListView(dept, layer) {
      this.$store.commit("mutationListLayer", {
        dept: dept,
        layer: layer
      });
    },
    methodCloseListLayer(dept, layer) {
      this.$store.commit("mutationCloseListLayer", {
        dept: dept,
        layer: layer
      });
    },
    // Global method to toggle single layer
    methodToggleSingleLayer(dept, layer, state, id) {
      // ensure state = false before opening single layer
      // fix for "double clicked" map/list view item bug
      if (state) {
        this.$store.commit("mutationSingleLayer", {
          dept: dept,
          layer: layer,
          state: false,
          id: id
        });
      }
      // wait 50ms so that the above "close" mutation has
      // time to run
      setTimeout(() => {
        this.$store.commit("mutationSingleLayer", {
          dept: dept,
          layer: layer,
          state: state,
          id: id
        });
      }, 50);
    },
    // set a layer visibile true/false
    methodSetMapLayerVisibility(dept, layer, state) {
      console.log("methodmsmlv", dept, layer, state);
      this.$store.commit("mutationMapLayerVisible", {
        dept: dept,
        layer: layer,
        visible: state
      });
    },
    // Global method to zoom map to a coordinate pair
    zoomTo(payload) {
      this.$store.commit("mutationZoomTo", {
        center: payload.center,
        level: payload.level
      });
    },
    // Global method to draw a point at a coordinate pair
    drawPoint(payload) {
      this.$store.commit("mutationDrawPoint", {
        center: payload.center
      });
    },
    // Format a date in a PostgreSQL approved way
    pgDateFunc(date) {
      function zeroPad(d) {
        return ("0" + d).slice(-2);
      }
      let parsed = new Date(date);

      return [
        parsed.getUTCFullYear() +
          "-" +
          zeroPad(parsed.getMonth() + 1) +
          "-" +
          zeroPad(parsed.getDate()) +
          " " +
          zeroPad(parsed.getHours()) +
          ":" +
          zeroPad(parsed.getMinutes()) +
          ":" +
          zeroPad(parsed.getSeconds())
      ].join(" ");
    }
  }
};
